module.exports = {"apply_customized":{"href":"business_services_registration","target":"_blank"},"order_hourly":{"href":"order?hourly_plan","target":"_blank"},"hourly_price_modal":"#hourly-price"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/business/link.json
// module id = 483
// module chunks = 0 1 2 3 4 5